import { useContext } from "react";
import { RootStore } from "../stores/RootStore";
import { StoreContext } from "../hocs/useStore";

export const useStores = (): RootStore => useContext(StoreContext);
